/**
 *
 * ManduUsersDrawer
 *
 */

import React from "react"
import { Drawer, Select, Tabs } from "antd"
import { Form } from "@ant-design/compatible"
import collect from "collect.js"
import { isEqual } from "lodash"
import "./index.less"
import UserMandu from "./SubComponent/Structure/UserMandu"
import UserManduTitle from "./SubComponent/Structure/UserManduTitle"
import UserManduFooter from "./SubComponent/Structure/UserManduFooter"
import TabsUserMandu from "./SubComponent/Structure/TabsUserMandu"
import "@ant-design/compatible/assets/index.css"

const { TabPane } = Tabs
const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
class ManduUsersDrawer extends React.Component {
  state = {
    tab: "1",
    isNew: false,
    selectCompanies: [],
    currentData: { companiesUserAccesses: [] },
    currentDataBackup: {},
    tabsAdmin: [
      { name: "Permisos", key: "1" },
      { name: "Información", key: "2" },
    ],
    tabsSuperAdmin: [{ name: "Información", key: "1" }],
    disableButtonAddCompanyAccess: true,
    itemSelectCompanyAccess: null,
  }

  componentDidMount() {
    this.setState({ isNew: !this.props.userSelected.id })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.userSelected, nextProps.userSelected)) {
      this.props.form.resetFields()
      this.setState({
        currentData: { ...nextProps.userSelected },
        isNew: !nextProps.userSelected.id,
      })
    }
    if (this.props.visible !== nextProps.visible && nextProps.visible) {
      this.setState({
        tab: "1",
        currentData: { ...nextProps.userSelected },
        currentDataBackup: { ...nextProps.userSelected },
      })
    }
  }

  removeItemListCompanyAccessCreate = (item) => {
    const { companiesUserAccesses } = this.state.currentData
    const { currentData } = this.state

    const collection = collect(companiesUserAccesses)
    const collectionWithoutItem = collection.reject(
      (value) => value.id_company === item.id_company
    )
    currentData.companiesUserAccesses = collectionWithoutItem.toArray()
    this.props.deleteSubmitCompaniesUserAccess(item)
    this.setState({ currentData })
  }

  activeButtonSelectedItemAccess = (item) => {
    this.setState({ disableButtonAddCompanyAccess: false })
    if (item == null) this.setState({ disableButtonAddCompanyAccess: true })
    this.setState({ itemSelectCompanyAccess: item })
  }

  selectItemCompanyAccessCreate = async () => {
    const { itemSelectCompanyAccess, currentData } = this.state
    const { companiesUserAccesses } = currentData
    const collection = collect(companiesUserAccesses)
    collection.push(itemSelectCompanyAccess)
    await this.setState({ disableButtonAddCompanyAccess: true })
    await this.setState({ itemSelectCompanyAccess: null })
    currentData.companiesUserAccesses = collection.toArray()
    await this.setState({ currentData })
    this.props.saveSubmitSaveCompanyUserAccess(itemSelectCompanyAccess)
  }

  setStateForm = (key, value) => {
    const { currentData } = this.state
    currentData[key] = value
    this.setState({ currentData })
  }

  setSelectedTab = (e) => {
    this.setState({ tab: e })
  }

  render() {
    const { visible } = this.props
    const { isNew, tab } = this.state

    return (
      <Drawer
        className="ManduUserDrawerComponent"
        title={<UserManduTitle {...this.props} {...this.state} />}
        width={520}
        closable
        visible={visible}
        onClose={() => {
          this.props.form.resetFields()
          this.props.hide(isNew, tab)
        }}>
        <TabsUserMandu
          {...this.props}
          {...this.state}
          setSelectedTab={this.setSelectedTab}
        />
        <UserMandu
          removeItem={(item) => this.removeItemListCompanyAccessCreate(item)}
          selectItem={(item) => this.selectItemCompanyAccessCreate(item)}
          activeButtonSelectedItemAccess={(item) =>
            this.activeButtonSelectedItemAccess(item)
          }
          setStateForm={this.setStateForm}
          {...this.props}
          {...this.state}
        />
        <UserManduFooter {...this.props} {...this.state} />
      </Drawer>
    )
  }
}

ManduUsersDrawer.propTypes = {}
const ManduUsersDrawerF = Form.create({ name: "mandu_user_administrator" })(
  ManduUsersDrawer
)

export default ManduUsersDrawerF
